import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { Dispatch, SetStateAction } from "react";
import { sxButtons, sxCloseIconButton, sxModal } from "./sxProps";
import { useNavigate } from "react-router-dom";
import { faCircleCheck } from "@fortawesome/pro-duotone-svg-icons";
import { useAccessibility } from "../../../../../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../../../../../components/Accessibility/PageTitle";
import DefaultText from "../../../../../../../components/Accessibility/DefaultText";
import DefaultButton from "../../../../../../../components/Accessibility/DefaultButton";

interface Props {
  showModal: boolean;
  setShowConfirmacaoModal: Dispatch<SetStateAction<boolean>>;
  dateHour: () => string;
}

const ConfirmacaoModal: React.FC<Props> = ({
  showModal,
  setShowConfirmacaoModal,
  dateHour,
}) => {
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const voltar = () => {
    navigate('/home')
    setShowConfirmacaoModal(false);
  };

  return (
    <Modal open={showModal}>
      <Box
        sx={sxModal}
        style={{
          ...accessibility.textStyleAccessibility,
          ...accessibility.contrastBorderAccessibility,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => voltar()}
          sx={sxCloseIconButton}
        >
          <FontAwesomeIcon
            icon={faTimes}
            size="1x"
            color="black"
            style={accessibility.textStyleAccessibility}
          />
        </IconButton>
        <FontAwesomeIcon icon={faCircleCheck} color="#00995D" size="3x" />
        <PageTitle
          marginBottom="15px"
          shouldFocus={false}
          text="Agendamento realizado com sucesso!"
        />
        <DefaultText
          alignCenter
          text={`O seu atendimento foi agendado para o dia ${dateHour()}.</br></br>
            No dia e horário agendado, nossa equipe entrará em contato no seu celular cadastrado. Pedimos que fique atento e próximo ao telefone.</br></br> 
            Você pode conferir os detalhes deste agendamento, a qualquer momento, em Saúde e Bem-estar > Gestão de crônicos > Meus agendamentos. Caso haja algum imprevisto também é possível cancelar.`}
        />
        <Box sx={sxButtons}>
          <DefaultButton
            text="MEUS AGENDAMENTOS"
            onClick={() => navigate("/saudeOnline/meusAgendamentos")}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmacaoModal;
